"use client";
import React, { useState } from "react";
import Link from "next/link";
import { Card, ListGroup, Badge, Button } from "react-bootstrap";
import { Eye } from "lucide-react";
import styles from "./BlogCard.module.css";
import Image from "next/image";
import DomBlg from "../../../../public/aiimg/domad.png"
import DomN from "../../../../public/aiimg/dom.png"
import Server from "../../../../public/aiimg/server.png"
export interface BlogPost {
  id: string;
  slug?: string;
  title: string;
  image?: string;
  views: number;
}

export interface BlogCategory {
  name: string;
  count: number;
  slug?: string;
}

interface Props {
  categories: BlogCategory[];
  popularPosts: BlogPost[];
  selectedCategory: string;
  onCategorySelect: (c: string) => void;
  totalCount?: number;
}

const slugify = (t: string) =>
  t
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const formatViews = (views: number): string => {
  if (views >= 1000000)
    return (views / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  if (views >= 1000) return (views / 1000).toFixed(1).replace(/\.0$/, "") + "k";
  return views.toString();
};

export const BlogSidebar: React.FC<Props> = ({
  categories,
  popularPosts,
  selectedCategory,
  onCategorySelect,
  totalCount,
}) => {
  const INITIAL_CATEGORIES_COUNT = 10;
  const [showAllCategories, setShowAllCategories] = useState(false);

  // Determine which categories to show based on state
  const displayedCategories = showAllCategories
    ? categories
    : categories.slice(0, INITIAL_CATEGORIES_COUNT);

  // Check if there are more categories to show
  const hasMoreCategories = categories.length > INITIAL_CATEGORIES_COUNT;

  return (
    <div className="d-flex flex-column gap-4">
      <div className="my-4 text-center">
          <Link
            href="/dedicated-servers-usa"
            target="_blank"
            className="d-block"
          >
            <Image
              src={Server}
              width={300}
              height={500}
              alt="Dedicated Servers USA"
              className="img-fluid rounded-4"
            />
          </Link>
        </div>
      {/* ---------- Categories ---------- */}
      <Link  href="/ai-hosting" target="_blank" className="d-block text-center">
                  <Image src={DomBlg} width={300} height={500} className="my-2 mx-auto rounded-4" alt="..."/>
                  
                </Link> 

                   {/* ---------- Popular Posts ---------- */}
      <Card className={styles.sidebarCard}>
        <Card.Header className={styles.sidebarHeader}>
          Popular Posts
        </Card.Header>
        <ListGroup variant="flush">
          {popularPosts.map((p) => (
            <ListGroup.Item key={p.id} className={styles.sidebarListItem}>
              <div className="d-flex gap-3 align-items-center">
                {p.image ? (
                  <div className={styles.popularThumb}>
                    <Image
                      src={p.image}
                      alt={p.title}
                      width={60}
                      height={60}
                      className="rounded-3 object-fit-cover"
                    />
                  </div>
                ) : (
                  <div className={styles.popularThumbPlaceholder}>📰</div>
                )}
                <div className="flex-grow-1">
                  <Link
                    href={`/blog/${
                      p.slug ??
                      p.title
                        .toLowerCase()
                        .trim()
                        .replace(/[^a-z0-9]+/g, "-")
                        .replace(/^-+|-+$/g, "")
                    }`}
                    className={styles.popularLink}
                  >
                    {p.title}
                  </Link>
                  <div className="d-flex align-items-center gap-1 small text-muted mt-1">
                    <Eye size={12} />
                    <span>{formatViews(p.views)} views</span>
                  </div>
                </div>
              </div>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Card>

      
      <Card className={styles.sidebarCard}>
        <Card.Header className={styles.sidebarHeader}>Categories</Card.Header>
        <ListGroup variant="flush">
          {/* All Posts */}
          <ListGroup.Item
            action
            active={selectedCategory === ""}
            className={`${styles.sidebarListItem}`}
          >
            <Link
              href="/blog"
              className={`${styles.sidebarCategoryLink}`}
              onClick={() => onCategorySelect("")}
            >
              <span>All Posts</span>
              <Badge className={styles.sidebarBadge} pill>
                {totalCount ?? categories.reduce((s, c) => s + c.count, 0)}
              </Badge>
            </Link>
          </ListGroup.Item>

          {/* Category Items */}
          {displayedCategories.map((c) => (
            <ListGroup.Item
              key={c.name}
              action
              active={selectedCategory === c.name}
              className={`${styles.sidebarListItem}`}
            >
              <Link
                href={`/blog/category/${encodeURIComponent(c.slug ?? slugify(c.name))}`}
                className={`${styles.sidebarCategoryLink}`}
                onClick={() => onCategorySelect(c.name)}
              >
                <span>{c.name}</span>
                <Badge className={styles.sidebarBadge} pill>
                  {c.count}
                </Badge>
              </Link>
            </ListGroup.Item>
          ))}

          {/* Load More / Show Less Button */}
          {hasMoreCategories && (
            <ListGroup.Item>
              <Button
                variant="link"
                size="sm"
                className="w-100 py-2 text-decoration-none"
                style={{
                  color: "#f36b21",
                  fontWeight: 600,
                  border: "none",
                }}
                onClick={() => setShowAllCategories(!showAllCategories)}
              >
                {showAllCategories ? "Show Less" : "Show More"}
              </Button>
            </ListGroup.Item>
          )}
        </ListGroup>
      </Card>
 
  
   
      <Link href="/domain-registrations" className="d-block text-center" target="_blank">
        <Image src={DomN} width={300} height={500} alt="..." className="mx-auto text-center  rounded-4" />
         
       </Link>
    </div>
  );
};
